<script lang="ts">
  import { page } from '@inertiajs/svelte'
  import { faCamera, faRightToBracket, faScaleBalanced, faShieldHalved, faSwatchbook } from '@fortawesome/free-solid-svg-icons'
  import { inertia } from '../utils/inertia'
  import { getI18n } from '../i18n'
  import Icon from './Icon.svelte'
  import MirroredIcon from './MirroredIcon.svelte'

  const i18n = getI18n()
  const year = new Date().getFullYear()
  const imprintHref = $derived(i18n.path('/imprint'))
  const privacyPolicyHref = $derived(i18n.path('/privacy'))
  const mediaLicenseHref = $derived(i18n.path('/media-license'))
</script>

<footer class="footer">
  <p class="footer-copyright">© {year} Visit Augsburg</p>
  <ul class="footer-list">
    <li class="footer-item">
      <a href={imprintHref} {@attach inertia({ href: imprintHref })} class="footer-link">
        <Icon icon={faScaleBalanced} />
        {i18n.t('footer.imprint')}
      </a>
    </li>
    <li class="footer-item">
      <a href={privacyPolicyHref} {@attach inertia({ href: privacyPolicyHref })} class="footer-link">
        <Icon icon={faShieldHalved} />
        {i18n.t('footer.privacy')}
      </a>
    </li>
    <li class="footer-item">
      <a href={mediaLicenseHref} {@attach inertia({ href: mediaLicenseHref })} class="footer-link">
        <Icon icon={faCamera} />
        {i18n.t('footer.mediaLicense')}
      </a>
    </li>
    {#if page.props.developmentPaths}
      <li class="footer-item">
        <a href={page.props.developmentPaths.designSystem} {@attach inertia({ href: page.props.developmentPaths.designSystem })} class="footer-link -development">
          <Icon icon={faSwatchbook} />
          Design System
        </a>
      </li>
      <li class="footer-item">
        <!-- No Inertia visit: the backend is a separate Inertia app and needs a full page load. -->
        <a href={page.props.developmentPaths.login} class="footer-link -development">
          <MirroredIcon icon={faRightToBracket} />
          Login
        </a>
      </li>
    {/if}
  </ul>
</footer>

<style>
  .footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-5) var(--space-9);
    margin-top: var(--space-24);
    padding-block: var(--space-9);
    border-top: var(--border-style-1);
    font-size: var(--font-size-4);
  }

  .footer-copyright {
    margin: 0;
    font-size: inherit;
    color: var(--color-text-muted);
  }

  .footer-list {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-3) var(--space-9);
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: inherit;
  }

  .footer-item {
    display: flex;
  }

  .footer-link {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    color: var(--color-text-muted);
    text-decoration: none;
    transition: color var(--transition-fast);

    &:hover {
      color: var(--color-text);
      text-decoration: underline;
    }

    &.-development {
      color: var(--color-variant-warning);
    }
  }
</style>
